// Shared between CookieConsent.tsx (writes) and GoogleAnalyticsLoader.tsx
// (reads) so the storage key and event name aren't duplicated in two files
// and can't drift out of sync.

export const CONSENT_STORAGE_KEY = 'cookie_consent';

// Dispatched on `window` when the visitor makes a choice in the banner, so
// GoogleAnalyticsLoader (already mounted, already past its own read of
// localStorage on initial mount) can react in the same tab immediately —
// a `storage` event only fires in *other* tabs, never the one that made
// the change.
export const CONSENT_EVENT = 'cookie-consent-changed';

export type ConsentValue = 'accepted' | 'declined';
